<template>
    <div style="overflow: hidden;">
        <div class="login" v-if="useIntenalLayout">
            <div style="display:flex;flex-direction: column; align-items: center; height: 100%  ;">
                <Row class="header">
                    <div class="description">
                        上海麦信打造一流的物联网数据服务解决方案
                    </div>
                    <div class="text">
                        a professional elevator Internet of things solution company
                    </div>
                </Row>
                <div style="flex: 1; display:flex; align-items: center; justify-content:center;">
                    <Row class="login-form">
                        <div class="text">欢迎使用上海麦信智慧电梯数据平台V3.0</div>
                        <div class="text-2">CubeE Connectivity V3.0</div>
                        <div style="padding:0 83px">
                            <Form ref="usernameLoginForm" :model="form" :rules="rules" @keydown.enter.native="submitLogin">
                                <FormItem prop="userName">
                                    <Input v-model="form.userName" prefix="ios-contact" clearable placeholder="请输入用户名" autocomplete="off" />
                                </FormItem>
                                <FormItem prop="passWord">
                                    <Input type="password" v-model="form.passWord" prefix="ios-lock" clearable placeholder="请输入密码" autocomplete="off" />
                                </FormItem>
                                <FormItem prop="userName" v-if="shoeCode">
                                    <Input v-model="form.verifyCode" prefix="ios-barcode" clearable placeholder="请输入验证码" autocomplete="off" />
                                </FormItem>
                            </Form>
                            <Row>
                                <Button class="login-btn" type="primary" size="large" :loading="loading" @click="submitLogin" long>
                                    <span v-if="!loading">登录</span>
                                    <span v-else>登录中...</span>
                                </Button>
                            </Row>
                        </div>
                    </Row>
                </div>
                <div class="footer">
                    <div>
                        Copyright © 2023 www.shmashine.com All rights reserved.
                    </div>
                    <div style="display:flex; align-items: center; justify-content: center;">
                        <img style="width:23px; height: 24px; margin-right: 5px;" src="@/assets/gh.png">
                        <a style="color: #fff;" href="https://beian.miit.gov.cn/" target="_blank"> 沪ICP备16041439号</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="login" v-else>
            <div style="display:flex;flex-direction: column; align-items: center; height: 100%  ;">
                 <Row class="header">
                    <div class="description" style="margin-top:50px">
                        翼智梯管理平台
                    </div>
                </Row>
                <div style="flex: 1; display:flex; align-items: center; justify-content:center;margin-bottom:150px">
                    <Row class="login-form">
                        <div style="padding:90px 83px 30px 83px">
                            <Form ref="usernameLoginForm" :model="form" :rules="rules" @keydown.enter.native="submitLogin">
                                <div class="input-wrapper">
                                    <FormItem prop="userName">
                                        <Input v-model="form.userName" prefix="ios-contact" clearable placeholder="请输入用户名" autocomplete="off" />
                                    </FormItem>
                                </div>
                                <div class="input-wrapper">
                                    <FormItem prop="passWord">
                                        <Input type="password" v-model="form.passWord" prefix="ios-lock" clearable placeholder="请输入密码" autocomplete="off" />
                                    </FormItem>
                                </div>
                                <FormItem prop="userName" v-if="shoeCode">
                                    <Input v-model="form.verifyCode" prefix="ios-barcode" clearable placeholder="请输入验证码" autocomplete="off" />
                                </FormItem>
                            </Form>
                            <Row>
                                <Button class="login-btn" type="primary" size="large" :loading="loading" @click="submitLogin" long>
                                    <span v-if="!loading">登录</span>
                                    <span v-else>登录中...</span>
                                </Button>
                            </Row>
                        </div>
                    </Row>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const hostWhiteList = ['iot.shmashine.com', 'nps.shmashine.com','localhost','10.0.0.188']
import { login } from "@/api/loginApi";
export default {
    data() {
        const validateMobile = (rule, value, callback) => {
            var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
            if (!reg.test(value)) {
                callback(new Error("手机号格式错误"));
            } else {
                callback();
            }
        };
        return {
            useIntenalLayout: true,
            error: false,
            errorMsg: "",
            tabName: "username",
            saveLogin: true,
            loading: false,
            sending: false,
            sended: false,
            count: 60,
            countButton: "60 s",
            maxLength: 6,
            errorCode: "",
            shoeCode: false,
            form: {
                userName: "",
                passWord: "",
                verifyCode: null,
            },
            rules: {
                userName: [{
                    required: true,
                    message: "账号不能为空",
                    trigger: "blur",
                }, ],
                passWord: [{
                    required: true,
                    message: "密码不能为空",
                    trigger: "blur",
                }, ],
                verifyCode: [{
                    required: true,
                    message: "验证码不能为空",
                    trigger: "blur",
                }, ],
            },
        };
    },
    created(){
        this.autoLogin();
    },
    mounted() {
        this.useIntenalLayout = hostWhiteList.indexOf(window.location.hostname) > -1
    },
    methods: {
        // 获取地址栏token参数登录
        autoLogin() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.size > 0 && urlParams.has('sso_token')) {
                console.log('yilogin')
                this.$Spin.show();
                const ssoToken = urlParams.get('sso_token');
                this.$store
                    .dispatch("menu/loginStoreByUrl", { telecomToken: ssoToken })
                    .then((res) => {
                        this.$router.push({ path: res });
                        this.$Spin.hide();
                    })
                    .catch((response) => {
                        console.log('error=', response)
                        this.$Spin.hide();
                        if (response.data.info && response.data.info.needVerifyPhone) {
                            this.$Message.success("已发送短信至您的手机,请查收");
                            this.shoeCode = true;
                            return
                        }
                        if (response.data.message) {
                            this.$Message.error(response.data.message);
                        }

                    });
            }

        },
        submitLogin() {
            this.$refs["usernameLoginForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.$store
                        .dispatch("menu/loginStore", this.form)
                        .then((res) => {
                            this.$router.push({ path: res });
                            this.loading = false;
                        })
                        .catch((response) => {
                            this.loading = false;

                            if (response.data.info && response.data.info.needVerifyPhone) {
                                this.$Message.success("已发送短信至您的手机,请查收");
                                this.shoeCode = true;
                                return
                            }
                            if (response.data.message) {
                                this.$Message.error(response.data.message);
                            }

                        });
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./login.scss";

.input-wrapper:first-of-type {
    margin-bottom: 25px;
}

.test {
    width: 100px;
    height: 900px;
    background-color: pink;
}
.login .login-form .login-btn{
    margin-top: 10px;
}
::v-deep {
  .ivu-form-item{
    // border: 1px solid red;
    margin-bottom: 24px;
  }
  .ivu-input-wrapper {
    .ivu-icon {
      height: 100%;
      line-height: 100%;
      align-items: center;
    }

    .ivu-icon::after,
    .ivu-icon::before {
      line-height: 42px;
    }

  }

}
</style>